import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import videoFile from '../assets/Home/0503 (1).mp4';
import homeImage from '../assets/Home/52.jpeg';

// Import carousel images
import image1 from '../assets/Home/2.jpeg';
import image2 from '../assets/Home/13.jpeg';
import image3 from '../assets/Home/17.jpeg';
import image4 from '../assets/Home/24.jpeg';
import image5 from '../assets/Home/WhatsApp Image 2025-05-03 at 16.jpeg';
import image6 from '../assets/Home/30.jpeg';
import image7 from '../assets/Home/53.jpeg';
import image8 from '../assets/Home/20.jpeg';
import image9 from '../assets/Home/WhatsApp Image 2025-05-03 at 17.jpeg';
import image10 from '../assets/Home/18.jpeg';

import provideImage from '../assets/Home/FotoJet.jpg';
import volunteerBgImage from '../assets/Home/52.jpeg';

import { FaDonate, FaHandsHelping, FaGraduationCap } from 'react-icons/fa';

const Home = () => {
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);
    const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
    const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 992);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setWindowWidth(width);
            setIsMobile(width < 768);
            setIsTablet(width >= 768 && width < 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const homes = [
        { image: image1, name: "St.Theresa's Home" },
        { image: image2, name: "Marcsri Home" },
        { image: image3, name: "Mama Papa Home" },
        { image: image4, name: "St.Mary's Home" },
        { image: image5, name: "Cardinal Cooray Home" },
        { image: image6, name: "St.Ann's Home" },
        { image: image7, name: "St.Albert's Home" },
        { image: image8, name: "Marco Home" },
        { image: image9, name: "St.Martin's Home" },
        { image: image10, name: "Mendis Home" },
    ];

    const cardStyle = {
        transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease-in-out, background-color 0.3s ease-in-out',
    };

    const cardHoverStyle = {
        transform: 'scale(1.05)',
        boxShadow: '0 10px 20px rgba(0,0,0,0.2)',
        backgroundColor: 'rgba(100, 100, 100, 0.8)',
    };

    useEffect(() => {
        const script = document.createElement('script');
        script.src = 'https://widget.trustmary.com/afO5t5j45';
        script.async = true;
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    // Determine number of cards per slide based on screen size
    const getCardsPerSlide = () => {
        if (windowWidth < 576) return 1; // Extra small devices
        if (windowWidth < 768) return 2; // Small devices (mobile)
        if (windowWidth < 992) return 3; // Medium devices (tablet)
        return 4; // Large devices and up
    };

    const cardsPerSlide = getCardsPerSlide();

    // Helper function to determine font sizes based on device
    const getFontSize = (mobileSize, tabletSize, desktopSize) => {
        if (isMobile) return mobileSize;
        if (isTablet) return tabletSize;
        return desktopSize;
    };

    // Helper function to determine spacing based on device
    const getSpacing = (mobileSize, tabletSize, desktopSize) => {
        if (isMobile) return mobileSize;
        if (isTablet) return tabletSize;
        return desktopSize;
    };

    return (
        <>
            {/* Video Section - Responsive Height */}
            <div className="position-relative p-0" style={{
                height: isMobile ? '50vh' : isTablet ? '70vh' : '100vh',
                width: '100vw',
                overflow: 'hidden',
                marginTop: isMobile ? '0' : '20px'
            }}>
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    className="position-absolute top-0 start-0"
                    style={{
                        width: '100vw',
                        height: '100%',
                        objectFit: 'cover'
                    }}
                >
                    <source src={videoFile} type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark" style={{ opacity: 0.5 }}></div>

                <div className="position-absolute top-50 start-50 translate-middle text-center text-white px-3">
                    <h1 className={isMobile ? "h2 fw-bold" : isTablet ? "h1 fw-bold" : "display-4 fw-bold"} style={{ fontFamily: 'Georgia' }}>
                        Welcome to Marcsri Homes
                    </h1>
                    <p className={isMobile ? "small" : isTablet ? "lead" : "lead"}>
                        Discover our mission to provide safe and loving homes for those in need. Join us in making a difference.
                    </p>
                </div>
            </div>

            {/* Section: Left and Right Layout - Stack on mobile */}
            <div className="container my-5">
                <div className="row">
                    <div className="col-md-6 p-3 p-md-4 order-md-1" style={{ marginTop: getSpacing('20px', '30px', '40px') }}>
                        <h2 className="fw-bold mb-3" style={{
                            fontFamily: 'Georgia',
                            fontSize: getFontSize('2em', '2.5em', '3em')
                        }}>
                            MARCSRI HOMES
                        </h2>
                        <p className="text-muted" style={{ fontSize: getFontSize('0.9rem', '1rem', '1rem') }}>
                            Marcsri Homes offers shelter, compassion, and a family to about 270 elderly mothers and fathers, children, men, and women fully or partially, mentally or physically disabled across 10 homes all over the country. Marcsri provides the security of a HOME to the old, the feeble, the bedridden, the terminal, and the differently abled regardless of ethnicity or religion. These orphanages/homes for disabled persons and elders' homes are run by the Archbishop of Colombo, under the guidance and supervision of Seth Sarana Caritas, the social arm of the Archdiocese of Colombo.
                        </p>
                    </div>

                    <div className="col-md-6 p-3 p-md-4 order-md-2">
                        <img
                            src={homeImage}
                            alt="Marcsri Homes"
                            className="img-fluid rounded"
                            style={{
                                maxHeight: getSpacing('250px', '350px', '400px'),
                                objectFit: 'cover',
                                width: '100%'
                            }}
                        />
                    </div>
                </div>
            </div>

            {/* Section: Our Homes - Responsive Carousel */}
            <div className="container my-5">
                <h2 className="fw-bold mb-4 text-center" style={{
                    fontSize: getFontSize('2em', '2.5em', '3em'),
                    fontFamily: 'Georgia'
                }}>
                    Our Homes
                </h2>
                <div className="position-relative">
                    <div
                        id="carouselExampleControls"
                        className="carousel slide"
                        data-bs-ride="carousel"
                        data-bs-pause="hover"
                    >
                        <div className="carousel-inner">
                            {Array.from({ length: Math.ceil(homes.length / cardsPerSlide) }).map((_, slideIndex) => (
                                <div key={slideIndex} className={`carousel-item ${slideIndex === 0 ? 'active' : ''}`}>
                                    <div className="row justify-content-center g-4">
                                        {homes.slice(slideIndex * cardsPerSlide, slideIndex * cardsPerSlide + cardsPerSlide).map((home, idx) => (
                                            <div key={idx} className="col-10 col-sm-8 col-md-6 col-lg-4 col-xl-3">
                                                <div
                                                    className="card h-100 mx-2 mx-md-3"
                                                    style={{
                                                        ...cardStyle,
                                                        maxWidth: '300px',

                                                    }}
                                                    onMouseEnter={(e) => {
                                                        e.currentTarget.style.transform = cardHoverStyle.transform;
                                                        e.currentTarget.style.boxShadow = cardHoverStyle.boxShadow;
                                                    }}
                                                    onMouseLeave={(e) => {
                                                        e.currentTarget.style.transform = 'none';
                                                        e.currentTarget.style.boxShadow = 'none';
                                                    }}
                                                >
                                                    <img
                                                        src={home.image}
                                                        className="card-img-top"
                                                        alt={home.name}
                                                        style={{
                                                            height: getSpacing('200px', '250px', '300px'),
                                                            objectFit: 'cover',
                                                            width: '100%'
                                                        }}
                                                        onError={(e) => {
                                                            e.target.src = 'https://via.placeholder.com/300x200?text=Image+Not+Found';
                                                        }}
                                                    />
                                                    <div className="card-body d-flex flex-column">
                                                        <h5 className="card-title">{home.name}</h5>
                                                        <button className="btn btn-primary mt-auto">Read More</button>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                    {/* Carousel controls - Black arrows without background */}
                    <button
                        className="carousel-control-prev"
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="prev"
                        style={{
                            width: '40px',
                            height: '40px',
                            top: '50%',
                            left: '0',
                            transform: 'translateY(-40%)',
                            opacity: 1,
                            filter: 'brightness(0)' // Makes the arrow pure black
                        }}
                    >
                        <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Previous</span>
                    </button>
                    <button
                        className="carousel-control-next"
                        type="button"
                        data-bs-target="#carouselExampleControls"
                        data-bs-slide="next"
                        style={{
                            width: '40px',
                            height: '40px',
                            top: '50%',
                            right: '0',
                            transform: 'translateY(-50%)',
                            opacity: 1,
                            filter: 'brightness(0)' // Makes the arrow pure black
                        }}
                    >
                        <span className="carousel-control-next-icon" aria-hidden="true"></span>
                        <span className="visually-hidden">Next</span>
                    </button>
                </div>
            </div>

            {/* Section: We provide - Stack on mobile */}
            <div className="container my-5">
                <h2 className="fw-bold mb-4 text-center" style={{
                    fontSize: getFontSize('2em', '2.5em', '3em'),
                    fontFamily: 'Georgia'
                }}>
                    We provide, but not limited to
                </h2>
                <div className="row align-items-center">
                    <div className={`col-md-6 p-3 p-md-4 ${isMobile ? 'order-2' : ''}`}>
                        <div className="position-relative">
                            <img
                                src={provideImage}
                                alt="We Provide Services"
                                className="img-fluid rounded shadow-lg"
                                style={{
                                    maxHeight: getSpacing('300px', '400px', '500px'),
                                    objectFit: 'cover',
                                    width: '100%'
                                }}
                            />
                            <div className="position-absolute top-0 start-0 w-100 h-100 bg-gradient rounded" style={{
                                background: 'linear-gradient(to top, rgba(0, 0, 0, 0.3), transparent)',
                                opacity: 0.8,
                                zIndex: 1
                            }}></div>
                        </div>
                    </div>

                    <div className={`col-md-6 p-3 p-md-4 ${isMobile ? 'order-1' : ''}`}>
                        <div className="bg-light p-3 p-md-4 rounded shadow-sm">
                            <h3 className="fw-bold mb-3 text-dark" style={{
                                fontSize: getFontSize('1.8em', '2.2em', '2.5em'),
                                fontFamily: 'Georgia'
                            }}>
                                Our Services
                            </h3>
                            <ul className="list-unstyled">
                                {['Food', 'Medicines', 'Accommodation', 'Education', 'Medical Equipment', 'Clothing', 'Social Work', 'Transportation'].map((service, index) => (
                                    <li key={index} className="mb-2 mb-md-3 d-flex align-items-center">
                                        <span className="me-2" style={{
                                            width: '10px',
                                            height: '10px',
                                            backgroundColor: ['goldenrod', 'blue', 'blue', 'red', 'green', 'blue', 'purple', 'purple'][index],
                                            borderRadius: '50%'
                                        }}></span>
                                        <span className="text-muted" style={{ fontSize: getFontSize('0.9rem', '1rem', '1rem') }}>
                                            {service}
                                        </span>
                                    </li>
                                ))}
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section: Our Needs - Adjust padding and font sizes */}
            <div className="container my-5">
                <h2 className="fw-bold mb-4 text-center" style={{
                    fontSize: getFontSize('2em', '2.5em', '3em'),
                    fontFamily: 'Georgia'
                }}>
                    Our Needs
                </h2>
                <div className="p-3 p-md-4 bg-white border border-success rounded shadow" style={{
                    borderStyle: 'dashed',
                    backgroundImage: 'url("data:image/svg+xml,%3Csvg width=\'12\' height=\'12\' viewBox=\'0 0 12 12\' fill=\'none\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cpath d=\'M6 0L7.22697 3.77304L11.134 4.54006L8.567 7.22697L9.05964 11.134L6 9.567L2.94036 11.134L3.433 7.22697L0.865993 4.54006L4.77304 3.77304L6 0Z\' fill=\'%23c3e6cb\'/%3E%3C/svg%3E")',
                    backgroundSize: '12px 12px'
                }}>
                    <div className="row g-3 g-md-4">
                        {['Almsgivings', 'Rations', 'Donations'].map((need, index) => (
                            <div key={index} className="col-md-4">
                                <div
                                    className="p-3 p-md-4 bg-light rounded text-center shadow-sm h-100"
                                    style={cardStyle}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = cardHoverStyle.transform;
                                        e.currentTarget.style.boxShadow = cardHoverStyle.boxShadow;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'none';
                                        e.currentTarget.style.boxShadow = 'none';
                                    }}
                                >
                                    <h3 className="fw-bold mb-2 mb-md-3 text-dark" style={{
                                        fontSize: getFontSize('1.5em', '2em', '3em'),
                                        fontFamily: 'Georgia'
                                    }}>
                                        {need}
                                    </h3>
                                    <p className="text-muted mb-3 mb-md-4" style={{ fontSize: getFontSize('0.9rem', '1rem', '1rem') }}>
                                        {need === 'Almsgivings' ? "Sponsor the meals of our homes with almsgivings" :
                                            need === 'Rations' ? "Provide our daily needs of rations." :
                                                "Sponsor us with your generous donations to provide for our inmates"}
                                    </p>
                                    <a href="/our-homes">
                                        <button className="btn btn-light text-muted border">Read More</button>
                                    </a>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Section: Volunteer - Adjust height and content */}
            <div className="container my-5">
                <div
                    className="position-relative p-0 rounded shadow-lg"
                    style={{
                        height: isMobile ? '400px' : isTablet ? '450px' : '500px',
                        backgroundImage: `url(${volunteerBgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        backgroundRepeat: 'no-repeat'
                    }}
                >
                    <div className="position-absolute top-0 start-0 w-100 h-100 bg-dark" style={{ opacity: 0.6 }}></div>
                    <div className="position-absolute top-50 start-50 translate-middle text-center text-white w-100 px-3">
                        <div className="p-3 p-md-4 rounded shadow" style={{
                            maxWidth: isMobile ? '100%' : isTablet ? '350px' : '400px',
                            margin: '0 auto',
                            backgroundColor: 'rgba(255, 255, 255, 0.6)',
                            backdropFilter: 'blur(5px)'
                        }}>
                            <h2 className="fw-bold mb-2 mb-md-3 text-dark" style={{
                                fontSize: getFontSize('1.8em', '2.2em', '3em'),
                                fontFamily: 'Georgia'
                            }}>
                                Volunteer
                            </h2>
                            <p className="text-muted mb-3 mb-md-4" style={{ fontSize: getFontSize('0.9rem', '1rem', '1rem') }}>
                                Join with our Marcsri family and help us to take care of these inmates – spend time with our children and elderly mothers and fathers, lend a helping hand
                            </p>
                            <Link to="/volunteers">
                                <button className="btn btn-success">Join Us Now</button>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>

            {/* Section: Get Involved - Adjust padding and font sizes */}
            <div className="container my-5">
                <h2 className="fw-bold mb-4 text-center" style={{
                    fontSize: getFontSize('2em', '2.5em', '3em'),
                    fontFamily: 'Georgia'
                }}>
                    Get Involved
                </h2>
                <div className="p-3 p-md-4 bg-dark rounded shadow" style={{ backgroundColor: '#4a5568' }}>
                    <div className="row g-3 g-md-4">
                        {[
                            {
                                icon: <FaDonate style={{ fontSize: getFontSize('30px', '35px', '40px'), color: '#316CF4' }} />,
                                title: "Give Donation",
                                text: "Support us to continue our service"
                            },
                            {
                                icon: <FaHandsHelping style={{ fontSize: getFontSize('30px', '35px', '40px'), color: '#316CF4' }} />,
                                title: "Become a Volunteer",
                                text: "Join our Marcsri family by giving your valuable time and service"
                            },
                            {
                                icon: <FaGraduationCap style={{ fontSize: getFontSize('30px', '35px', '40px'), color: '#316CF4' }} />,
                                title: "Give Scholarship",
                                text: "Sponsor our disabled children for their education"
                            }
                        ].map((item, index) => (
                            <div key={index} className="col-md-4">
                                <div
                                    className="p-3 p-md-4 bg-light rounded text-center shadow-sm h-100"
                                    style={cardStyle}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = cardHoverStyle.transform;
                                        e.currentTarget.style.boxShadow = cardHoverStyle.boxShadow;
                                        e.currentTarget.style.backgroundColor = cardHoverStyle.backgroundColor;
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = 'none';
                                        e.currentTarget.style.boxShadow = 'none';
                                        e.currentTarget.style.backgroundColor = 'transparent';
                                    }}
                                >
                                    <div className="mb-2 mb-md-3">{item.icon}</div>
                                    <h3 className="fw-bold mb-2 mb-md-3 text-dark" style={{ fontSize: getFontSize('1.2em', '1.3em', '1.5em') }}>
                                        {item.title}
                                    </h3>
                                    <p className="text-muted mb-0" style={{ fontSize: getFontSize('0.9rem', '1rem', '1rem') }}>
                                        {item.text}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Home;